module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_9005.b2f34137.png";